// API calls of the multi-tenant package "docprefix" — document-number prefixes (server: routes/docSeries.ts).
import { apiRequest } from '../api';

export type DocKind = 'quotation' | 'invoice' | 'receipt';
export type DocSeriesInfo = { key: string; kind: DocKind; prefix: string; setting: string; isDefault: boolean };
export type CompanyDocSeries = {
  companyId: string; name: string; companyKind: 'firm' | 'merchant'; letter: string;
  series: DocSeriesInfo[]; retired: { kind: DocKind; prefix: string }[]; defaults: Record<string, string>;
};

export const docPrefixApi = {
  /** prefix → kind over every firm of this workspace (today's and earlier prefixes). */
  prefixMap: (): Promise<{ prefixes: Record<string, DocKind> }> => apiRequest('GET', '/doc-series'),
  /** One company's prefixes (admin). */
  company: (id: string): Promise<CompanyDocSeries> => apiRequest('GET', `/doc-series/companies/${encodeURIComponent(id)}`),
  /** Save a firm's prefixes (admin); '' = back to the product default. */
  saveCompany: (id: string, body: Partial<Record<DocKind, string>>): Promise<CompanyDocSeries> =>
    apiRequest('PUT', `/doc-series/companies/${encodeURIComponent(id)}`, body),
};
